export function getGoogleMapsLink({ lat, lng }) {
  const parsedLat = parseFloat(lat);
  const parsedLng = parseFloat(lng);

  if (isNaN(parsedLat) || isNaN(parsedLng)) {
    return 'https://maps.google.com/maps';
  }
  return `https://maps.google.com/maps?q=${parsedLat},${parsedLng}`;
}
